import isEmpty from 'lodash/isEmpty';
import throttle from 'lodash/throttle';

import * as types from './types';

const syncPersonMatchingPatterns = (force = false) => {
  return (dispatch, getState, {persons}) => {
    const locale = getState()?.localization?.locale;

    if (
      force ||
      getState()?.personMatchingPatterns?.locale !== locale ||
      isEmpty(getState()?.personMatchingPatterns?.list)
    ) {
      dispatch({type: types.PERSON_MATCHING_PATTERNS_REQUEST});

      return persons
        .getPersonMatchingPatterns({params: {locale}})
        .then((results) =>
          dispatch({
            type: types.PERSON_MATCHING_PATTERNS_SUCCESS,
            payload: {
              data: results?.data,
              locale,
            },
          }),
        )
        .catch((error) =>
          dispatch({
            type: types.PERSON_MATCHING_PATTERNS_FAILURE,
            error,
          }),
        );
    }
  };
};

const _throttledSyncPersonMatchingPatterns = throttle(
  (dispatch, force) => dispatch(syncPersonMatchingPatterns(force)),
  10000,
);

export const getPersonMatchingPatterns = (force) => {
  return (dispatch) => {
    return _throttledSyncPersonMatchingPatterns(dispatch, force);
  };
};
